module.exports = __webpack_public_path__ + "static/media/linkedin-social-media-svgrepo-com.3eeb7ec4.svg";